export default {
  page: {
    register: "注册",
    login: "登录",
    increase: "完善信息",
    phoneRegister: "手机注册",
    bindRegister: "绑定注册",
    bindLogin: "绑定信息",
    supplement: "补充资料",
    loginSuccess: "登录成功",
    retrievePassword: "找回密码",
    setPassword: "设置密码",
    loginTip: "登录提示",
  },
  common: {
    register: "注册",
    logout: "退出",
    hasAccount: "已有账号，立即登录",
    save: "保存",
    cancel: "取消",
    confirm: "确认",
    submit: "提交",
    back: "返回",
    nextStep: "下一步",
    loading: "加载中...",
    loginNow: "立即登录",
    registerNow: "立即注册",
    forgetPassword: "忘记密码",
    rememberPassword: "记住密码",
    getCaptcha: "获取验证码",
    captcha: "验证码",
    defaultLogin: "默认登录方式",
    otherLogin: "其他登录方式",
    captchaLogin: "验证码登录",
    passwordLogin: "密码登录",
    secondsLeft: "秒",
    noAccount: "没有账号？",
    savePassword: "保存密码",
    password: "密码",
    pleaseInputPassword: "请输入密码",
    phoneAreaCodeTip: "手机号请填写区号，如86",
    bind: "绑定",
    noRegisterBind: "没有注册？完善信息后绑定",
    hasAccountBind: "已有账号，登录后绑定",
    bindRegisterTip:
      "由于您是第一次使用微信/QQ账号登录，请完善您的账号信息，并创建密码用于后续登录。",
    bindLoginTitle: "请登录您的注册账号，完成身份绑定",
    bindRegisterTitle: "请完善您的账号信息，完成身份绑定",
  },
  field: {
    required: "请填写{name}",
    pattern: "请输入正确的{name}",
    unique: "{name}已注册",
    repeat: "{name}已存在",
    number: "请输入数字",
    phone: "手机号",
    correctPhone: "请输入正确的手机号",
    email: "邮箱",
    phoneOrEmail: "手机/邮箱",
    maxLength: "输入长度不超过{length}",
    please_select: "请选择",
    please_input: "请输入{name}",
    please_answer: "请回答",
    please_input_captcha: "请输入验证码",
    please_upload: "请上传",
  },
  login: {
    already_registered: "您输入的{name}已注册，请登录",
    passwordLengthError: "请输入6-20个字符",
    userUnderReview: "当前用户正在审核中，暂时无法绑定。",
    userDisabled: "当前用户已停用，暂时无法绑定。",
    pleaseAuthorizeFirst: "请先授权再进行绑定！",
    please_login: "请先登录",
    login_success: "登录成功",
    register_success: "注册成功",
    logout_success: "退出成功",
  },
  error: {
    100054: "输入的邮箱已存在报名信息，请输入其他邮箱",
  },
  lang: {
    zh_CN: "中文",
    en_US: "English",
    zh_TW: "繁體中文",
  },
};
